import { type PublicTenant } from '@rewardops/env'
import {
  GetAllParams,
  type BaseParams,
  type ItemsParams,
} from '@rewardops/utils'

import { createFilterString, type Filter } from './filter-builder'

const queryBuilder = {
  items: {
    getAll: (
      categoryCode: string,
      tenant: PublicTenant,
      params?: ItemsParams,
    ) => {
      return Object.assign(
        {},
        {
          page: 1,
          per_page_count: 24,
          detailed: true,
          sort_by: 'MEMBER_SALE_PRICE',
          sort_order: 'ASCENDING',
          in_stock: true,
          accept_language: tenant.locale.default,
          segment_code: tenant.roCacheSegmentCode,
          filter: categoryCode
            ? `(SIV_ATTRIBUTE(type)!="affiliate")&(CUSTOM_CATEGORY(true, offer_contract_segment)=="${categoryCode}")`
            : undefined,
        },
        params,
      )
    },
    getAllWithFilter: (
      filter: Filter,
      tenant: PublicTenant,
      params?: ItemsParams,
      page: number = 1,
      pageSize: number | null = 24,
    ) => {
      const filterString = createFilterString(filter, tenant)
      return Object.assign(
        {},
        {
          page: page,
          per_page_count: pageSize,
          detailed: true,
          sort_by: filter.sort?.by || 'MEMBER_SALE_PRICE',
          sort_order: filter.sort?.order || 'ASCENDING',
          in_stock: true,
          accept_language: tenant.locale.default,
          segment_code: tenant.roCacheSegmentCode,
          filter: filterString,
          q: filter?.q ?? '',
          starts_with: filter?.startsWith ?? '',
        },
        params,
      )
    },
    getOne: (params: ItemsParams, tenant: PublicTenant) => {
      return Object.assign(
        {},
        {
          segment_code: tenant.roCacheSegmentCode,
          permitted: true,
          in_stock: true,
        },
        params,
      )
    },
  },
  categories: {
    getAll: (params: BaseParams, tenant: PublicTenant) => {
      return {
        page: 1,
        per_page_count: 30,
        detailed: true,
        sort_by: 'MEMBER_SALE_PRICE',
        sort_order: 'ASCENDING',
        in_stock: true,
        accept_language: tenant.locale.default,
        segment_code: tenant.roCacheSegmentCode,
        filter: `(SIV_ATTRIBUTE(type)!="affiliate")`,
      }
    },
  },
  getQueryParameters: (tenant: PublicTenant, params: GetAllParams) => {
    return Object.assign(
      {},
      {
        segment_code: tenant.roCacheSegmentCode,
      },
      params,
    )
  },
}

// **** This needs to be exported this way to be used on the client side (otherwise server things are loaded) ****
export default queryBuilder
